import React from 'react';
import styled from 'styled-components/macro';

export const PlaceholderImage = () => <Image className="image" />;

export const Image = styled.div`
  width: 100%;
  height: 0;
  padding-top: 100%;
  display: block;
  position: relative;
`;
